import React from "react";
import { Button, Typography } from "antd";
import { useNavigate } from "react-router-dom";
import { AppPathNames } from "@/constants/AppPathNames";

import "./ForbiddenPage.scss";

const { Title, Text } = Typography;

const ForbiddenPage = () => {
  const navigate = useNavigate();

  const GoBack = () => {
    navigate(AppPathNames.root, { replace: true });
  };

  return (
    <div className="forbidden">
      <Title level={1} className="forbidden__header">
        403
      </Title>
      <Title level={1} className="forbidden__sub-header">
        Forbidden
      </Title>
      <Text className="forbidden__body">
        You don&apos;t have the permission to access this page!, head back to{" "}
        <Text className="forbidden__body--primary">Averroes.AI</Text>
      </Text>
      <Button className="forbidden__btn" type="primary" onClick={GoBack}>
        Go back
      </Button>
    </div>
  );
};

export default ForbiddenPage;
